var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"warning triangle outline\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52.281 52H7.56759C3.29238 52 0.617107 47.3757 2.74817 43.6696L25.105 4.78819C27.2425 1.07062 32.6062 1.0706 34.7438 4.78816L57.1007 43.6696C59.2316 47.3757 56.5564 52 52.281 52Z",
    stroke: "#DD7451",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.9243 18.6439L30 33",
    stroke: "#DD7451",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.9243 40.9091L29.9521 40.8783",
    stroke: "#DD7451",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.5feb5df7de9f91c4ba387091aec11f81.svg";
export { ForwardRef as ReactComponent };